import React from "react";
import CardContent from "./CardContent";

export default function Card({ provider, onClose }) {
  return (
    <div
      style={{
        position: "absolute",
        left: "0",
        zIndex: 102,
        top: 0,
        width: "100%",
        height: "100%",
        background: "white",
        borderLeft: "1px solid #eee",
        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
        // transform: provider ? "translateX(0)" : "translateX(-50px)",
        opacity: provider ? "1" : "0",
        pointerEvents: provider ? "all" : "none",
        transition: "all 100ms ease-in-out",
        // overflow: "auto",
      }}
    >
      <a
        href="#close"
        onClick={(e) => {
          e.preventDefault();
          onClose();
        }}
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          padding: 20,
          fontSize: 20,
          fontWeight: 900,
        }}
      >
        ✕
      </a>
      {provider && <CardContent provider={provider} />}
    </div>
  );
}
